import React from 'react'
import { useEffect, useState } from 'react';
import parse from 'html-react-parser';
import { ReactComponent as HeartIcon } from '../../assets/dashboard-home/HeartIcon.svg'
import { useGetVersionDetailQuery } from '../../services/attendance-portal/versionInformation';
import { useToggle } from '../../hooks';
import Modal from '../prime-react-overrides/modal/Modal';


function VersionInsights() {
    const { data: versionData, isLoading } = useGetVersionDetailQuery()
    const [currentVersion, setCurrentVersion] = useState(localStorage.getItem('cv') ?? '');
    const [showVersionInfo, setShowVersionInfo] = useToggle(false)
    let versionDataToDisplay = (versionData && !isLoading) ? versionData.dataForVersionChange : ''

    useEffect(() => {
        if (versionData?.currentVersion) {
            localStorage.setItem('cv', versionData.currentVersion)
            setCurrentVersion(versionData.currentVersion)
        }
    }, [versionData])

    return (
        <div>
            <Modal className="VersionUpdates" visible={showVersionInfo} onHide={setShowVersionInfo} draggable={false} header='Latest features' breakpoints={{ '640px': '100vw' }} style={{ width: '60vw' }}>
                {parse(versionDataToDisplay)}
            </Modal>
            <p className='p-0 m-0 text-center text-sm font-normal text-white mt-3 flex justify-content-center align-items-center '>Made with {<HeartIcon className='mx-1' />} in NY</p>
            <div className="w-full flex justify-content-center text-white text-sm font-normal relative pb-1">
                <span className='p-0 m-0 text-xs text-center cursor-pointer' onClick={setShowVersionInfo} > {currentVersion} </span>
                <a href="mailto:prabal.gupta@jaspercolin.com;sanjeet.kumar@jaspercolin.com?subject=Reporting a bug for Runway&cc=Shyamjee.Sudhakar@jaspercolin.com"
                    className='text-500 text-xs absolute right-0 mr-4'>
                    (Report a bug!)
                </a>
            </div>
        </div>
    )
}

export default VersionInsights
